<div class="dropzone-excel flex-direction-column gap-8"
     [class.arrastando]="arrastandoArquivo"
     (dragover)="aoArrastarSobre($event)"
     (dragleave)="aoArrastarSair($event)"
     (drop)="aoSoltarArquivo($event)">
  <div class="flex gap-10 align-center wrap">
    @if (podeEditar) {
      <div class="seletor-excel" role="button" tabindex="0"
           (click)="fileInput.click()" (keydown.enter)="fileInput.click()">
        <img src="assets/icones/arquivo-excel-black.svg" alt="">
        <span>Arraste o Excel aqui ou clique para selecionar</span>
        <input type="file" accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" #fileInput (change)="uploadArquivo($event);" hidden="" />
      </div>

      <button type="button" class="chip-exemplo cursor-pointer" (click)="baixarPlanilhaExemplo()">
        <img src="assets/icones/arquivo-excel-black.svg" alt="">
        <span class="font-12 weight-500">Baixar Planilha Exemplo.xls</span>
      </button>
    }

    @if (anexoArquivo) {
      <div class="container-arquivo flex justify-between padding-left-5px padding-right-5px">
        <div class="flex align-center gap-5 width-80">
          <img src="assets/icones/arquivo-excel-black.svg" alt="Arquivo Excel">
          <span class="font-12 weight-400 ellipse">{{ anexoArquivo?.nomeArquivo ?? '--' }}</span>
        </div>
        @if (podeEditar) {
          <div class="flex align-center">
            <img class="cursor-pointer" src="assets/icones/menu-vertical-black.svg" alt="Mais opções" matButton [matMenuTriggerFor]="menu">

            <mat-menu #menu="matMenu">
              <button class="font-12 weight-600" mat-menu-item type="button" (click)="deletarAnexo()">Deletar</button>
            </mat-menu>
          </div>
        }
      </div>
    }
  </div>
  @if (podeEditar) {
    <div class="flex-direction-column gap-5">
      <span class="dica-arrastar">*Necessário ter colunas: nome, telefone, email e cpf/cnpj | *Formato Telefone: DDI DD Número | *Formato CPF/CNPJ: apenas números</span>
    </div>
  }
</div>
